import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { EmbedSource, getEmbedSource } from 'src/app/core/util/root-element';

@Component({
  selector: 'fal-emergency-alert',
  templateUrl: './emergency-alert.component.html',
  styleUrls: ['./emergency-alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmergencyAlertComponent implements OnInit{
  @Input()
  public emergencyText: string;

  @Input()
  emergencyHeader: string;

  @Input()
  showViewMore:boolean;

  @Output()
  public closeClicked: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  toggleModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  isAEMEnvironment: boolean = false;
  public closeAlert(): void {
    this.closeClicked.emit();
  }

  public toggleModalClicked(): void {
    this.toggleModal.emit();
  }
  ngOnInit(): void {
    const embedSource = getEmbedSource();
    if (embedSource === EmbedSource.AEM) {
      this.isAEMEnvironment = true;
    }
  }
}
